import React from "react"
import Counter from "../../../components/counter"

const NAVY = "#2e4a66"
const WHITE = "#FFFFFF"

export default function ScreenBarPartner({context, campagneData}) {
    const partnerMontant = campagneData?.partnerMontant || 1
    const total = campagneData.stats.total.sum.total / partnerMontant

    const formater = new Intl.NumberFormat('fr-FR', {maximumFractionDigits: 0})
    const objectifLabel = campagneData.objectif > 1 ? "Enfants" : "Enfant"
    const totalLabel = total > 1 ? "Enfants" : "Enfant"

    return (
        <>

            {/* Texte "OBJECTIF : N ENFANTS" superposé au cadre déjà présent dans l'image */}
            <div style={{
                position: "absolute",
                top: "15%",
                left: 0,
                right: 0,
                textAlign: "center",
                color: NAVY,
                fontFamily: "ProximaNovaRouan, sans-serif",
                fontWeight: 900,
                fontSize: "3vh",
                letterSpacing: "2px",
                textTransform: "uppercase"
            }}>
                {`Objectif : ${formater.format(campagneData.objectif)} ${objectifLabel}`}
            </div>

            {/* Gros nombre script "10 enfants" entre les 2 carrés cyan */}
            <div style={{
                position: "absolute",
                top: "25%",
                left: 0,
                right: 0,
                textAlign: "center",
                color: WHITE,
                fontFamily: "DeseoMedium, cursive",
                fontWeight: 400,
                fontSize: "18vh",
                lineHeight: 1,
                whiteSpace: "nowrap"
            }}>
                <Counter number={total} decimals={0} preserveValue/>
                <span style={{marginLeft: "1.5vw"}}>{totalLabel.toLowerCase()}</span>
            </div>
        </>
    )
}

export function ScreenProgressBar({campagneData}) {
    const partnerMontant = campagneData?.partnerMontant || 1
    const total = campagneData.stats.total.sum.total / partnerMontant
    const displayPercent = Math.min((Number(campagneData.objectif)>0 ? (total / campagneData.objectif) * 100 : 0), 100)
    const formater = new Intl.NumberFormat('fr-FR', {maximumFractionDigits: 0})
    const showLabel = displayPercent >= 10

    return (
        <div style={{
            position: "absolute",
            left: "15%",
            right: "15%",
            bottom: "2%",
            height: "6.5%",
            backgroundColor: WHITE,
            overflow: "hidden",
            pointerEvents: "none"
        }}>
            <div style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: displayPercent + "%",
                height: "100%",
                backgroundColor: NAVY,
                transition: "width 1s ease",
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                paddingRight: "1.5vw",
                boxSizing: "border-box"
            }}>
                {showLabel && (
                    <span style={{
                        color: WHITE,
                        fontFamily: "ProximaNovaRouan, Archivo, sans-serif",
                        fontWeight: 900,
                        fontSize: "3.2vh",
                        letterSpacing: "1px",
                        whiteSpace: "nowrap"
                    }}>
                        {formater.format(displayPercent)}%
                    </span>
                )}
            </div>
        </div>
    )
}
